module.exports = __webpack_public_path__ + "static/media/homeImageMobile3x.e07294f4.png";